module.exports = __webpack_public_path__ + "img/image14.9d1a8ba8.png";